import React from "react";
import "./App.css";
import "./print.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ModeProvider } from "./context/ModeContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Portal from "./pages/Portal";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";
import InvitationLanding from "./pages/InvitationLanding";
import PrintDeck from "./pages/PrintDeck";
import ConnectorSetup from "./pages/ConnectorSetup";
import ConnectorDashboard from "./pages/ConnectorDashboard";

function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-ftext3 font-mono-data text-sm">
        Authenticating…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "connector" ? "/connector" : "/admin"} replace />;
  }
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="bottom-right" theme={theme === "light" ? "light" : "dark"} />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <ModeProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Portal />} />
                <Route path="/i/:token" element={<InvitationLanding />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/print" element={<PrintDeck />} />
                <Route path="/connector/setup" element={<ConnectorSetup />} />
                <Route
                  path="/connector"
                  element={
                    <ProtectedRoute role="connector">
                      <ConnectorDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute role="founder">
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <ThemedToaster />
          </ModeProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
